import { WebStorageStateStore } from 'oidc-client'
import isSendSalesForce from '../helpers/isSendSalesForce';

const grant_type = process.env.GRANT_TYPE;


 
const settings = {
  userStore: new WebStorageStateStore({ store : window.localStorage }),
  authority: process.env.AUTHORITY_AUTHZERO,
  audience: "corporate-authentication-membership-api",
  client_id: process.env.CLIENT_ID_AUTHZERO,
  api_advisor: process.env.API_ADVISOR,
  api_hub_menu: process.env.API_HUB_MENU,
  ocp_apim: process.env.OCP_APIM,
  token_type_hint: process.env.TOKEN_TYPE_HINT,
  redirect_uri: process.env.REDIRECT_URI_AUTHZERO,
  response_type: process.env.RESPONSE_TYPE,
  scope: process.env.SCOPE_AUTHZERO,
  post_logout_redirect_uri : process.env.POST_LOGOUT_REDIRECT_URI_AUTHZERO,
  script_faq : process.env.SCRIPT_FAQ,
  environment : process.env.ENVIRONMENT,
  extraQueryParams: {'isadvisor': true},
  script_mcp : process.env.SCRIPT_MCP,
  script_dynatrace : process.env.SCRIPT_DYNATRACE,
  hca_permissions: process.env.HCA_PERMISSIONS,
  hca_chat_url: process.env.HCA_CHAT_URL,
  melver_redirect_course_path: process.env.MELVER_REDIRECT_COURSE_PATH,
  melver_email_standardzation: process.env.MELVER_EMAIL_STANDARDIZATION,
};

if (grant_type !== "null") {
  settings.extraQueryParams.grant_type = grant_type;
}
settings.extraQueryParams.audience = process.env.EXTRAQUERYPARAMS_AUDIENCE_AUTHZERO;

if(!isSendSalesForce()) {
  settings.extraQueryParams.prompt = process.env.EXTRAQUERYPARAMS_PROMPT_AUTHZERO;
}

module.exports = settings;